import React, { useContext, useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import classNames from "classnames";
import * as Icons from "Components/Icons";
import { Button } from "Components/ReactstrapSlim";
import { Module, ModuleCaption } from "Components/Module";
import { PortalClient, VenueSearchResult } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import { VenueCard } from "../VenueCard";
import AccountContext from "../../AccountContext";

export interface VenuesProps {
   id: string | undefined //collection Id
}

export const Venues: React.FC<VenuesProps> = ({ id }) => {
   const portalClient = useApiClient(PortalClient);
   const account = useContext(AccountContext);
   const [venues, setVenues] = useState<VenueSearchResult[]>([]);
   const [collectionName, setCollectionName] = useState<string>("");
   const [isError, setIsError] = useState<boolean>(false);
   const [isLoading, setIsLoading] = useState<boolean>(true);
   const history = useHistory();   

   const loadData = async (abortSignal: AbortSignal) => {
      setIsLoading(true);
      try {
         if (id) {            
            portalClient.preferredCollectionVenues(account.id, id, abortSignal).then(result => {
               setVenues(result.venues || []);
               setCollectionName(result.name || "");
            }).catch(error => {
               setIsError(true);
            }).finally(() => {
               setIsLoading(false);
            });
         }
      }
      catch { }
   }

   useEffect(() => {
      const abortController = new AbortController();
      loadData(abortController.signal);

      return function cleanup() {
         abortController.abort();
      }
   }, []);

   return (<>
      <Link className="back-collections-link" to={"/collections"}><Icons.ArrowLeftAlt /><span className="back-collections-link-text">Back to Collections</span></Link>
      <Module size="lg" className={classNames("module-no-venues", { "d-none": isLoading || venues.length > 0 })}>
         <ModuleCaption className="title">{isError ? "Looks like this preffered collection isn't available anymore" : "You don't have any venues in this preffered collection yet"}</ModuleCaption>
         <div className="subtitle"></div>
         <div className="btn-wrapper">
            <Button color="arctic-20" size="sm" onClick={() => history.push("/collections")}>Go back</Button>
         </div>
      </Module>
      <Module size="lg" loading={isLoading} className={classNames("module-venues", { "d-none": venues.length == 0 })}>
         <ModuleCaption>
            <div className="collection-name">{collectionName}</div>
         </ModuleCaption>
         <div className="venues-wrapper">
            {venues.map(v => <VenueCard key={v.venueId} venue={v} onClick={() => window.open(`${v.url}`, "_blank")} />)}
         </div>
      </Module>
   </>);
}